import { useAuth } from '../lib/auth.jsx'

export default function AuthGate() {
  const { signIn, error, workspaceDomain } = useAuth()

  return (
    <div
      style={{
        position: 'relative',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--color-bg-dark)',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/assets/grain.svg')",
          opacity: 0.04,
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: 420,
          maxWidth: '92vw',
          background: 'var(--color-panel-dark)',
          border: '1px solid var(--color-divider-dark)',
          borderRadius: 'var(--radius-lg)',
          padding: '40px 36px',
          textAlign: 'left',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 11, marginBottom: 28 }}>
          <img src="/assets/mark.svg" alt="Career Nomad" style={{ width: 30, height: 30, display: 'block' }} />
          <span
            className="font-display"
            style={{ fontSize: 22, letterSpacing: '.02em', textTransform: 'uppercase', color: 'var(--color-white)', lineHeight: 1 }}
          >
            Caravan
          </span>
        </div>

        <div className="eyebrow" style={{ marginBottom: 14 }}>
          <span className="tag-label" style={{ color: 'var(--color-gold)' }}>Internal · Career Nomad</span>
        </div>
        <h1
          className="font-display"
          style={{ fontSize: 40, margin: '0 0 10px', lineHeight: 0.95, textTransform: 'uppercase', color: 'var(--color-white)' }}
        >
          Sign in to
          <br />
          your workspace
        </h1>
        <p style={{ margin: '0 0 28px', fontSize: 13, color: 'var(--color-muted)', lineHeight: 1.6 }}>
          {workspaceDomain
            ? `Use your @${workspaceDomain} Google account.`
            : 'Use your Google Workspace account.'}
        </p>

        <button onClick={signIn} className="btn btn-gold" style={{ width: '100%', justifyContent: 'center', fontSize: 13, padding: '13px 20px' }}>
          Continue with Google
        </button>

        {error && (
          <div style={{ marginTop: 16, fontSize: 12, color: 'var(--color-danger)', lineHeight: 1.5 }}>{error}</div>
        )}
      </div>
    </div>
  )
}
